<main>
    <kt-app-hero-section></kt-app-hero-section>
    <kt-app-featured-services-section></kt-app-featured-services-section>
    <kt-app-stats-section></kt-app-stats-section>
    <kt-app-features-details-section></kt-app-features-details-section>
    <kt-app-services-section></kt-app-services-section>
    <kt-app-pricing-section></kt-app-pricing-section>
    <kt-app-contact-section></kt-app-contact-section>
</main>